import api from '../api/api'
import { call, put, take } from 'redux-saga/effects'
import messagesSchema from '../schemas/messages'
import broadcastsSchema from '../schemas/broadcasts'
import smsSchema from '../schemas/sms'
import emailsSchema from '../schemas/emails'
import { normalize } from 'normalizr'
import { statusCodeIsBelow400, appendToFormData } from '../helpers/utility'

import {
  FETCH_USER_MESSAGES_REQUEST,
  FETCH_USER_MESSAGES_ASYNC_START,
  FETCH_USER_MESSAGES_ASYNC_END,
  FETCH_USER_MESSAGES_FAIL,
} from '../actions/actions'

import {
  FETCH_SINGLE_MESSAGE_REQUEST,
  FETCH_SINGLE_MESSAGE_SUCCESS,
  FETCH_SINGLE_MESSAGE_FAIL,
  FETCH_SINGLE_MESSAGE_ASYNC_START,
  FETCH_SINGLE_MESSAGE_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_NEW_MESSAGES_REQUEST,
  FETCH_NEW_MESSAGES_SUCCESS,
  FETCH_NEW_MESSAGES_FAIL,
} from '../actions/actions'

import {
  SET_SEEN_STATUS_REQUEST,
  SET_SEEN_STATUS_SUCCESS,
  SET_SEEN_STATUS_FAIL,
} from '../actions/actions'

import {
  SENT_MESSAGE_REQUEST,
  SENT_MESSAGE_SUCCESS,
  SENT_MESSAGE_FAIL,
  SENT_MESSAGE_ASYNC_END,
} from '../actions/actions'

import {
  BROADCAST_MESSAGE_REQUEST,
  BROADCAST_MESSAGE_SUCCESS,
  BROADCAST_MESSAGE_FAIL,
  BROADCAST_MESSAGE_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_BROADCASTS_REQUEST,
  FETCH_BROADCASTS_SUCCESS,
  FETCH_BROADCASTS_FAIL,
  FETCH_BROADCASTS_ASYNC_END,
  FETCH_BROADCASTS_ASYNC_START,
} from '../actions/actions'

import {
  FETCH_SINGLE_BROADCAST_REQUEST,
  FETCH_SINGLE_BROADCAST_SUCCESS,
  FETCH_SINGLE_BROADCAST_ASYNC_START,
  FETCH_SINGLE_BROADCAST_ASYNC_END,
  FETCH_SINGLE_BROADCAST_FAIL,
} from '../actions/actions'

import {
  FETCH_NEW_BROADCASTS_REQUEST,
  FETCH_NEW_BROADCASTS_SUCCESS,
  FETCH_NEW_BROADCASTS_FAIL,
  FETCH_NEW_BROADCASTS_ASYNC_START,
  FETCH_NEW_BROADCASTS_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_USER_BROADCASTS_REQUEST,
  // FETCH_USER_BROADCASTS_SUCCESS, instead we user FETCH_BROADCASTS_SUCCESS for better code reuse
  FETCH_USER_BROADCASTS_FAIL,
  FETCH_USER_BROADCASTS_ASYNC_START,
  FETCH_USER_BROADCASTS_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_MANAGER_EMAILS_REQUEST,
  FETCH_MANAGER_EMAILS_SUCCESS,
  FETCH_MANAGER_EMAILS_FAIL,
  FETCH_MANAGER_EMAILS_ASYNC_START,
  FETCH_MANAGER_EMAILS_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_MANAGER_SMS_REQUEST,
  FETCH_MANAGER_SMS_SUCCESS,
  FETCH_MANAGER_SMS_FAIL,
  FETCH_MANAGER_SMS_ASYNC_START,
  FETCH_MANAGER_SMS_ASYNC_END,
} from '../actions/actions'

import {
  SEND_EMAIL_REQUEST,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAIL,
  SEND_EMAIL_ASYNC_START,
  SEND_EMAIL_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_SINGLE_EMAIL_REQUEST,
  FETCH_SINGLE_EMAIL_SUCCESS,
  FETCH_SINGLE_EMAIL_FAIL,
  FETCH_SINGLE_EMAIL_ASYNC_START,
  FETCH_SINGLE_EMAIL_ASYNC_END,
} from '../actions/actions'

import {
  SEND_SMS_REQUEST,
  SEND_SMS_FAIL,
  SEND_SMS_SUCCESS,
  SEND_SMS_ASYNC_START,
  SEND_SMS_ASYNC_END,
} from '../actions/actions'

// function* fetchReceivedMessages(queryString, token) {
//   return yield call()
// }

// function* fetchSentMessages(queryString, token) {
//   return yield call(api.fetchSentMessages, queryString, token)
// }

function apiCallHandler(messageType, queryString) {
  if (messageType === 'received') {
    return api.fetchReceivedMessages(queryString)
  } else if (messageType === 'sent') {
    return api.fetchSentMessages(queryString)
  }
}

export function* fetchUserMessages() {
  while (true) {
    const { messageType, queryString } = yield take(FETCH_USER_MESSAGES_REQUEST)
    yield put({ type: FETCH_USER_MESSAGES_ASYNC_START })

    try {
      const {
        data: {
          data: { messages, count },
          status,
        },
      } = yield call(apiCallHandler, messageType, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: `FETCH_USER_${messageType.toUpperCase()}_MESSAGES_SUCCESS`,
          messages: normalize(messages, messagesSchema),
          count: count,
        })
      } else {
        yield put({ type: FETCH_USER_MESSAGES_FAIL })
      }

      yield put({ type: FETCH_USER_MESSAGES_ASYNC_END })
    } catch (error) {
      console.log(error)
      yield put({ type: FETCH_USER_MESSAGES_ASYNC_END })
      yield put({ type: FETCH_USER_MESSAGES_FAIL, error })
    }
  }
}

export function* getSingleMessage() {
  while (true) {
    const { messageId, resolve } = yield take(FETCH_SINGLE_MESSAGE_REQUEST)
    yield put({ type: FETCH_SINGLE_MESSAGE_ASYNC_START })

    try {
      const {
        data: { data, status },
      } = yield call(api.fetchSingleMessages, messageId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SINGLE_MESSAGE_SUCCESS,
          message: data.message,
        })

        resolve && resolve(data.message)
      } else {
        yield put({ type: FETCH_SINGLE_MESSAGE_FAIL })
      }

      yield put({ type: FETCH_SINGLE_MESSAGE_ASYNC_END })
    } catch (error) {
      yield put({
        type: FETCH_SINGLE_MESSAGE_FAIL,
        error,
      })
    }
  }
}

export function* getNotifications() {
  while (true) {
    yield take(FETCH_NEW_MESSAGES_REQUEST)

    try {
      const {
        data: { data, status },
      } = yield call(api.fetchNotifications)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_NEW_MESSAGES_SUCCESS,
          newMessages: normalize(data.messages, messagesSchema),
        })
      } else {
        yield put({ type: FETCH_NEW_MESSAGES_FAIL })
      }
    } catch (error) {
      yield put({ type: FETCH_NEW_MESSAGES_FAIL, error })
    }
  }
}

export function* SeenStatus() {
  while (true) {
    const { messageId } = yield take(SET_SEEN_STATUS_REQUEST)
    const formData = appendToFormData({ message: messageId })

    try {
      const {
        data: { status },
      } = yield call(api.setSeenStatus, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SET_SEEN_STATUS_SUCCESS,
        })
      } else {
        yield put({ type: SET_SEEN_STATUS_FAIL })
      }
    } catch (error) {
      console.log(error)
      yield put({ type: SET_SEEN_STATUS_FAIL, error })
    }
  }
}

export function* sendMessage() {
  while (true) {
    const { formData, resolve, reject } = yield take(SENT_MESSAGE_REQUEST)

    try {
      const {
        data: {
          status,
          data: { message },
        },
      } = yield call(api.sentMessage, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SENT_MESSAGE_SUCCESS,
          message,
        })

        resolve(message)
      } else {
        yield put({ type: SENT_MESSAGE_FAIL })

        reject()
      }

      yield put({ type: SENT_MESSAGE_ASYNC_END })
    } catch (error) {
      console.log(error)
      reject()
      yield put({ type: SENT_MESSAGE_FAIL, error })
    }
  }
}

export function* broadcastMessage() {
  while (true) {
    const { formData, resolve, reject } = yield take(BROADCAST_MESSAGE_REQUEST)
    try {
      const {
        data: {
          status,
          data: { broadcast },
          errors: { form_errors, general_errors },
        },
      } = yield call(api.broadcastMessage, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: BROADCAST_MESSAGE_SUCCESS,
          broadcast,
        })

        resolve(broadcast)
      } else {
        yield put({ type: BROADCAST_MESSAGE_FAIL })
        reject({ form_errors, general_errors })
      }
      yield put({ type: BROADCAST_MESSAGE_ASYNC_END })
    } catch (error) {
      reject()
      yield put({ type: BROADCAST_MESSAGE_FAIL, error })
      yield put({ type: BROADCAST_MESSAGE_ASYNC_END, error })
      console.log(error)
    }
  }
}

export function* BroadcastedMessages() {
  while (true) {
    const { queryString } = yield take(FETCH_BROADCASTS_REQUEST)
    yield put({ type: FETCH_BROADCASTS_ASYNC_START })

    try {
      const {
        data: { data, status },
      } = yield call(api.getBroadcastedMessages, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_BROADCASTS_SUCCESS,
          broadcasts: normalize(data.broadcasts, broadcastsSchema),
          count: data.count,
        })
      } else {
        yield put({ type: FETCH_BROADCASTS_FAIL })
      }

      yield put({ type: FETCH_BROADCASTS_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_BROADCASTS_FAIL })
      yield put({ type: FETCH_BROADCASTS_ASYNC_END })
    }
  }
}

export function* getSingleBroadcast() {
  while (true) {
    const { broadcastId, resolve } = yield take(FETCH_SINGLE_BROADCAST_REQUEST)
    yield put({ type: FETCH_SINGLE_BROADCAST_ASYNC_START })

    try {
      const {
        data: {
          data: { broadcast },
          status,
        },
      } = yield call(api.fetchSingleBroadcast, broadcastId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SINGLE_BROADCAST_SUCCESS,
          broadcast: broadcast,
        })

        resolve && resolve(broadcast)
      } else {
        yield put({ type: FETCH_SINGLE_BROADCAST_FAIL })
      }

      yield put({ type: FETCH_SINGLE_BROADCAST_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_SINGLE_BROADCAST_FAIL })
      yield put({ type: FETCH_SINGLE_BROADCAST_ASYNC_END })
    }
  }
}

export function* getUserBroadcasts() {
  while (true) {
    const { queryString } = yield take(FETCH_USER_BROADCASTS_REQUEST)
    yield put({ type: FETCH_USER_BROADCASTS_ASYNC_START })

    try {
      const {
        data: { data, status },
      } = yield call(api.getUserBroadcasts, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_BROADCASTS_SUCCESS,
          broadcasts: normalize(data.broadcasts, broadcastsSchema),
          count: data.count,
        })
      } else {
        yield put({ type: FETCH_USER_BROADCASTS_FAIL })
      }

      yield put({ type: FETCH_USER_BROADCASTS_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_USER_BROADCASTS_FAIL })
      yield put({ type: FETCH_USER_BROADCASTS_ASYNC_END })
    }
  }
}

export function* getBroadcastNotifications() {
  while (true) {
    yield take(FETCH_NEW_BROADCASTS_REQUEST)
    yield put({ type: FETCH_NEW_BROADCASTS_ASYNC_START })

    try {
      const {
        data: { data, status },
      } = yield call(api.getUserNewBroadcasts)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_NEW_BROADCASTS_SUCCESS,
          broadcasts: normalize(data.broadcasts, broadcastsSchema),
        })
      } else {
        yield put({ type: FETCH_NEW_BROADCASTS_FAIL })
      }

      yield put({ type: FETCH_NEW_BROADCASTS_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_NEW_BROADCASTS_FAIL })
      yield put({ type: FETCH_NEW_BROADCASTS_ASYNC_END })
    }
  }
}

export function* getManagerEmails() {
  while (true) {
    const { queryString } = yield take(FETCH_MANAGER_EMAILS_REQUEST)
    yield put({ type: FETCH_MANAGER_EMAILS_ASYNC_START })

    try {
      const {
        data: { data, status },
      } = yield call(api.getManagerEmails, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_MANAGER_EMAILS_SUCCESS,
          emails: normalize(data.emails, emailsSchema),
          count: data.count,
        })
      } else {
        yield put({ type: FETCH_MANAGER_EMAILS_FAIL })
      }

      yield put({ type: FETCH_MANAGER_EMAILS_ASYNC_END })
    } catch (error) {
      console.log(error)
      yield put({ type: FETCH_MANAGER_EMAILS_FAIL })
      yield put({ type: FETCH_MANAGER_EMAILS_ASYNC_END })
    }
  }
}

export function* getManagerSms() {
  while (true) {
    const { queryString } = yield take(FETCH_MANAGER_SMS_REQUEST)
    yield put({ type: FETCH_MANAGER_SMS_ASYNC_START })

    try {
      const {
        data: { data, status },
      } = yield call(api.getManagerSms, queryString)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_MANAGER_SMS_SUCCESS,
          smsMessages: normalize(data.smss, smsSchema),
          count: data.count,
        })
      } else {
        yield put({ type: FETCH_MANAGER_SMS_FAIL })
      }

      yield put({ type: FETCH_MANAGER_SMS_ASYNC_END })
    } catch (error) {
      console.log(error)
      yield put({ type: FETCH_MANAGER_SMS_FAIL })
      yield put({ type: FETCH_MANAGER_SMS_ASYNC_END })
    }
  }
}

export function* sendEmail() {
  while (true) {
    const { formData, resolve, reject } = yield take(SEND_EMAIL_REQUEST)
    yield put({ type: SEND_EMAIL_ASYNC_START })

    try {
      const {
        data: {
          status,
          data: { email },
          errors: { form_errors, general_errors },
        },
      } = yield call(api.sendEmail, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SEND_EMAIL_SUCCESS,
          email,
        })

        resolve(email)
      } else {
        yield put({ type: SEND_EMAIL_FAIL })
        reject({ form_errors, general_errors })
      }

      yield put({ type: SEND_EMAIL_ASYNC_END })
    } catch (error) {
      reject()
      yield put({ type: SEND_EMAIL_FAIL, error })
      yield put({ type: SEND_EMAIL_ASYNC_END, error })
      console.log(error)
    }
  }
}

export function* sendSms() {
  while (true) {
    const { formData, resolve, reject } = yield take(SEND_SMS_REQUEST)
    yield put({ type: SEND_SMS_ASYNC_START })

    try {
      const {
        data: {
          status,
          data: { sms },
          errors: { form_errors, general_errors },
        },
      } = yield call(api.sendSms, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SEND_SMS_SUCCESS,
          sms,
        })

        resolve(sms)
      } else {
        yield put({ type: SEND_SMS_FAIL })
        reject({ form_errors, general_errors })
      }

      yield put({ type: SEND_SMS_ASYNC_END })
    } catch (error) {
      console.log(error)
      reject()
      yield put({ type: SEND_SMS_FAIL, error })
      yield put({ type: SEND_SMS_ASYNC_END, error })
    }
  }
}

export function* getSingleEmail() {
  while (true) {
    const { emailId, resolve } = yield take(FETCH_SINGLE_EMAIL_REQUEST)
    yield put({ type: FETCH_SINGLE_EMAIL_ASYNC_START })

    try {
      const {
        data: {
          data: { email },
          status,
        },
      } = yield call(api.fetchSingleEmail, emailId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_SINGLE_EMAIL_SUCCESS,
          email: email,
        })

        resolve && resolve(email)
      } else {
        yield put({ type: FETCH_SINGLE_BROADCAST_FAIL })
      }

      yield put({ type: FETCH_SINGLE_EMAIL_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_SINGLE_EMAIL_FAIL })
      yield put({ type: FETCH_SINGLE_EMAIL_ASYNC_END })
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/messagesSaga.js